import apiClient from './client';

// Abgeleiteter Status pro Person für ein Stammbaum-Overlay (eine Erkrankung).
// 'inconsistent' = Daten-/Vererbungswiderspruch (z.B. betroffenes Kind bei
// dominanter Erkrankung ohne betroffenes Elternteil → de novo oder Datenfehler).
export type OverlayStatus =
  | 'affected'
  | 'obligate_carrier'
  | 'at_risk'
  | 'unaffected_observed'
  | 'unknown'
  | 'inconsistent';

export interface OverlayPerson {
  status: OverlayStatus;
  /** Trägerwahrscheinlichkeit (0..1) für 'at_risk'; null = nicht berechenbar (NIE 0 als Platzhalter). */
  carrierProbability: number | null;
}

export interface TreeOverlay {
  catalogId: string;
  label: string;
  pattern: string | null;
  /** Personen-ID → abgeleiteter Status. Fehlt eine Person → wie 'unknown' behandeln. */
  statuses: Record<string, OverlayPerson>;
  counts: Record<OverlayStatus, number>;
  /** Anzahl lebender Personen, deren Inferenz unterdrückt wurde (Recht auf Nichtwissen / fehlender Consent). */
  suppressedCount: number;
  disclaimer: string;
}

export async function getTreeOverlay(catalogId: string): Promise<TreeOverlay> {
  const { data } = await apiClient.get<TreeOverlay>(`/medical/overlay/${catalogId}`);
  return data;
}
